import type { Env } from '../../../context/env-context';
import { shopifyThemeSetupUrl } from '../../../lib/platform-links';

export { isShopify } from '../../../context/env-context';

export const isWix = (platform: Env['platform']): boolean => platform === 'wix';

export const isWoocommerce = (platform: Env['platform']): boolean => platform === 'woocommerce';

/** Shopify admin deep-link to the app's theme-setup screen, or null without a store. */
export function themeSetupUrl(env: Env): string | null {
  return shopifyThemeSetupUrl(env.store_id);
}
